<template>
	<div class="content-wrapper">
		<div class="sf-flex-column">
			<!-- 조회부분 시작 -->
			<!--<div class="sf-col sf-col-7">-->
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<pc-idx-num-3-m-search ref="search" :scrId="scrId" />
				</sf-card>
			</div>
			<!-- 조회부분 끝 -->

			<!-- 그래프 부분 시작 -->
			<div class="sf-col sf-col-12">
				<sf-card class="p-0 border-0 bg-transparent">
					<pc-idx-num-3-m-graph ref="graph" @Refresh="Refresh" :scrId="scrId"></pc-idx-num-3-m-graph>
				</sf-card>
			</div>
			<!-- 그래프 부분 끝 -->
			<!-- 그리드 부분 시작 -->
			<div class="sf-col sf-col-8">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<pc-idx-num-3-m-table ref="table" @Refresh="Refresh" :scrId="scrId"></pc-idx-num-3-m-table>
				</sf-card>
			</div>
			<!-- 그리드 부분 시작 -->
		</div>
	</div>
</template>

<script>
import PcIdxNum3MSearch from './Search/PcIdxNum3MSearch.vue';
import PcIdxNum3MTable from './Table/PcIdxNum3MTable.vue';
import PcIdxNum3MGraph from './Table/PcIdxNum3MGraph.vue';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {};
	},
	created() {
		console.clear();
	},
	components: { PcIdxNum3MSearch, PcIdxNum3MTable, PcIdxNum3MGraph },
	methods: {
		Refresh() {
			this.$refs.search.searchList();
		}
	}
};
</script>

<style></style>
